import "./Components/cart/CartDiscountField";
//
import "../scss/nutribe-cart.scss";
import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.start();

console.log("cart js loadedi", Alpine);
